export default __webpack_public_path__ + "static/media/konteyner.eaf494f5.svg";